import { render, staticRenderFns } from "./ModuleFrame.vue?vue&type=template&id=5e907af4&scoped=true&"
import script from "./ModuleFrame.vue?vue&type=script&lang=js&"
export * from "./ModuleFrame.vue?vue&type=script&lang=js&"
import style0 from "./ModuleFrame.vue?vue&type=style&index=0&id=5e907af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e907af4",
  null
  
)

export default component.exports